class ProductPriceHistoryController extends AbstractController
	@register()
	@inject 'ProductRepository'

	initialize: ->
		@filter =
			product_category_id: null
			product_id: null
			product_variant_id: null
			from: moment().startOf('month').unix()
			to: moment().unix()

		@datePickerConfig =
			singleDatePicker: true

		@currentProductVariants = []

	onSelectedProductChange: (product) ->
		@filter.product_variant_id = null
		@currentProductVariants = []

		query = @ProductRepository.createQuery()
		query.with('product_variants')

		@ProductRepository
			.getEntity(product.id, query)
			.then (item) =>
				@currentProductVariants = item.product_variants ? []
